<template>
    <div class="moow-notification">
        <md-button class="md-icon-button notification-close-btn" @click="close">
            <md-icon>clear</md-icon>
        </md-button>
        <p>{{title}}</p>
        <p>{{content}}</p>
    </div>
</template>


<script>
// Example usage
//  <moow-button :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      false: false,
    }
  },
  components: {},
  data() {
    return {
    };
  },
  filters: {},
  computed: {
  },
  mounted() {},
  created() {
  },
  methods: {
    close() {
    },
  },
};
</script>
<style scoped lang="scss">
.moow-notification{
    position: absolute;
    width: 340px;
    height: 85px;
    top: 1em;
    right: 1em;

    background: #DEF7EC;
    border: 1px solid #84E1BC;
    box-sizing: border-box;
    /* shadow-md */

    box-shadow: 0px 4px 6px rgba(26, 32, 46, 0.1);
    border-radius: 6px;
}

.notification-close-btn{
    position: inherit;
    top: 0;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/interface/dialogs/moowNotification.vue